import $api from "../http";

export default class MerchantService {
  static async addMerchantDatesToAllShops(merchantId, open_hours) {
    return $api.put(`/Merchants/${merchantId}/shops/openHours`, { open_hours });
  }
}
